import { render, staticRenderFns } from "./collect-b2b-return.vue?vue&type=template&id=f9526a44"
import script from "./collect-b2b-return.vue?vue&type=script&lang=js"
export * from "./collect-b2b-return.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports